import { createTheme } from "@mui/material/styles";
import { defaultTheme } from "./default";

const root = {
  "& .MuiInputBase-input::-webkit-inner-spin-button": {
    display: "none"
  },
  "& .MuiFormHelperText-root": {
    marginLeft: "0px",
    fontSize: "0.9rem",
    fontWeight: "300"
  },
  "& .MuiInputBase-input.Mui-disabled": {
    background: "#FAFAFA"
  },
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#ffffff",
    "& fieldset": {
      border: "1px solid #C4C4C4"
    },
    "&:hover fieldset": {
      border: "1px solid #C4C4C4"
    },
    "&.Mui-focused fieldset": {
      border: `1px solid ${defaultTheme.colors.base}`
    }
  },
  "& .MuiFormLabel-root.Mui-focused": {
    color: defaultTheme.colors.base
  }
};

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: defaultTheme.colors.base,
    },
    secondary: {
      main: defaultTheme.colors["white-100"],
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: defaultTheme.colors["white-100"],
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: defaultTheme.colors.base,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: defaultTheme.colors.base,
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root,
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        listbox: {
          maxHeight: "300px",
          overflowY: "auto",
          borderRadius: 12,
          boxShadow: '0 4px 16px rgba(0,0,0,0.08) !important',
          background: '#fff',
          padding: 0,
          '&::-webkit-scrollbar': {
            width: "8px",
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: defaultTheme.colors.base,
            borderRadius: "4px",
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: defaultTheme.colors.base,
            borderRadius: "4px",
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: defaultTheme.colors.base,
          },
          scrollbarWidth: "thin",
          scrollbarColor: `${defaultTheme.colors.base} #f0f0f0`,
        },
        paper: {
          borderRadius: 12,
          boxShadow: '0 4px 16px rgba(0,0,0,0.08) !important',
        },
        option: {
          borderRadius: 8,
          minHeight: 48,
          fontSize: 16,
          color: '#1f201e',
          padding: '8px 16px',
          transition: 'background 0.2s',
          cursor: 'pointer',
          '&.MuiTouchRipple-root': {
            borderRadius: 8,
          },
        },
        inputRoot: {
          '& .MuiAutocomplete-input': {
            padding: '4px',
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          boxShadow: '0 4px 16px rgba(0,0,0,0.08) !important',
          borderRadius: 8,
          maxHeight: '300px',
        },
        list: {
          maxHeight: '300px',
          overflowY: 'auto',
          '&::-webkit-scrollbar': {
            width: "8px",
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: defaultTheme.colors.base,
            borderRadius: "4px",
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: defaultTheme.colors.base,
            borderRadius: "4px",
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: defaultTheme.colors.base,
          },
          scrollbarWidth: "thin",
          scrollbarColor: `${defaultTheme.colors.base} #f0f0f0`,
        },
      },
    },
  },
});
